function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";

var useSelectRange = function useSelectRange(options, values) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      lastClicked = _useState2[0],
      setLastClicked = _useState2[1];

  var getSelections = function getSelections(clickedOption, isShiftKey, isSelected) {
    var selectedIndex = options.findIndex(function (option) {
      return option.value === clickedOption.value;
    });
    var isDeselectRange = isShiftKey && lastClicked && !lastClicked.selected;
    var isSelectRange = isShiftKey && lastClicked && lastClicked.selected;

    var getRange = function getRange() {
      var range = selectedIndex > lastClicked.index ? options.slice(lastClicked.index, selectedIndex + 1) : options.slice(selectedIndex, lastClicked.index);
      return range.filter(function (item) {
        return !item.disabled;
      });
    };

    var deselectOption = function deselectOption() {
      return values.filter(function (selected) {
        return selected.value !== clickedOption.value;
      });
    };

    var deselectRange = function deselectRange() {
      return values.filter(function (selected) {
        return !getRange().find(function (item) {
          return item.value === selected.value;
        });
      });
    };

    var selectOption = function selectOption() {
      return [].concat(_toConsumableArray(values), [clickedOption]);
    };

    var selectRange = function selectRange() {
      var added = getRange().filter(function (item) {
        return !values.find(function (selected) {
          return selected.value === item.value;
        });
      });
      return [].concat(_toConsumableArray(values), _toConsumableArray(added));
    };

    setLastClicked({
      index: selectedIndex,
      selected: !isSelected
    });

    if (isSelected) {
      return isDeselectRange ? deselectRange() : deselectOption();
    }

    return isSelectRange ? selectRange() : selectOption();
  };

  return {
    getSelections: getSelections,
    setLastClicked: setLastClicked
  };
};

export default useSelectRange;